import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-188f3a87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tariffs" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_tariffs_unique_filters = _resolveComponent("tariffs-unique-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_title, { title: "Уникальные тарифы" }),
    _createVNode(_component_tariffs_unique_filters, {
      class: "mt-6",
      loading: _ctx.state.is_loading,
      onSearch: _ctx.applyFilters,
      onResetted: _ctx.resetFilters
    }, null, 8, ["loading", "onSearch", "onResetted"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка тарифов произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadCompaniesUnique(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.BillingUniqueTariffsColumns,
                rows: _ctx.state.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadCompaniesUnique,
                onChangeLimit: _ctx.onLimitChange
              }, {
                td: _withCtx(({ column, row }) => [
                  (column.key === 'billing')
                    ? (_openBlock(), _createBlock(_component_cheap, {
                        key: 0,
                        class: _normalizeClass(['small w-min', { green: row.billing_enabled }])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getBillingTitle(row.billing_enabled)), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    : (column.key === 'name')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: `/tariffs/unique/${row.id}`,
                          class: "tariffs__link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                        ], 64))
                ]),
                actions: _withCtx(({ row }) => [
                  (row.contract_id)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/contracts/${row.contract_id} `
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_the_button, {
                            class: "primary small",
                            hint: "Показать основной договор"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}